export default "__VITE_PUBLIC_ASSET__cd091ae0__"